<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import { useJoakimStore } from '@/stores/useJoakimStore'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import PEP from '../Shared/PEP.vue'
import Undirritun from '../Shared/Undirritun.vue'
import LokaSkref from '../Shared/LokaSkref.vue'
import ApplicationBarnalifeyriBegin from './Steps/ApplicationBarnalifeyriBegin.vue'

const joakim = useJoakimStore()

async function runBankCheck(umsokn: any) {
  const res = await joakim.checkBankaReikning(umsokn)
  const data = (res as any)?.data ?? res
  const valid = !!data?.valid
  return { valid, errorMessage: valid ? '' : (data?.message || 'Ógildur bankareikningur') }
}

const steps = [
  { comp: ApplicationBarnalifeyriBegin,  titleKey: '' },
  { comp: Umsaekjandi,  titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,        titleKey: 'barnalifeyrir_umsokn_step2_header' },
  { comp: Step3,        titleKey: 'barnalifeyrir_umsokn_step3_header', props: { runBankCheck } },
  { comp: Step4,        titleKey: 'barnalifeyrir_umsokn_step4_header' },
  { comp: PEP,          titleKey: 'umsokn_PEP_header' },
  { comp: Step5,        titleKey: 'umsokn_samantekt_header' },
  { comp: Undirritun,   titleKey: 'undirritun_umsokn_header1' },
]
</script>

<template>
  <ApplicationBase :app-id="12" update-key="barnalifeyrir" :steps="steps" />
</template>
